<div class="pos-r">
  <app-loader *ngIf="loading"></app-loader>
  <div class="pt-24 pb-24">
    <div class="mb-24">
      <div class="grid">
        <div class="grid__box grid__box--size-5">
          <div class="grid">
            <div class="grid__box grid__box--size-6">
              <div class="title title--s">
                Время, с которого СИ могут<br />
                самостоятельно брать заявки для<br />
                исполнения в текущий день
              </div>
            </div>
            <div class="grid__box grid__box--size-6">
              <app-time-picker [(ngModel)]="timeMounterAssignTickets" (ngModelChange)="onChangeTimeMounterAssignTickets($event)"></app-time-picker>
            </div>
          </div>
        </div>
        <div class="grid__box grid__box--size-5">
          <div class="grid">
            <div class="grid__box grid__box--size-6">
              <div class="title title--s">
                Время, с которого Диспетчеры<br />
                могут назначать заявки на бригады,<br />
                стоящие в графике на завтрашний<br />
                день
              </div>
            </div>
            <div class="grid__box grid__box--size-6">
              <app-time-picker [(ngModel)]="timeNextDayToAssignTickets" (ngModelChange)="onChangeTimeNextDayToAssignTickets($event)"></app-time-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="grid">
        <div class="grid__box grid__box--size-5">
          <div class="grid">
            <div class="grid__box grid__box--size-6">
              <div class="title title--s">
                Количество следующих дней, из<br />
                графика которых можно<br />
                назначать/брать в работу заявки<br />
                для исполнения в текущий день
              </div>
            </div>
            <div class="grid__box grid__box--size-min">
              <div class="days-count__block">
                <app-field>
                  <input type="text" class="input-text" maxlength="8" fieldRegexp [regexp]="'[^0-9]'" [(ngModel)]="countDaysToAssigment" />
                </app-field>
              </div>
            </div>
          </div>
        </div>
        <div class="grid__box grid__box--size-5">
          <div class="grid">
            <div class="grid__box grid__box--size-6">
              <div class="title title--s">
                Количество открытых аварий на<br />
                коммутаторах, при превышении<br />
                которого они перестают<br />
                импортироваться
              </div>
            </div>
            <div class="grid__box grid__box--size-min">
              <div class="days-count__block">
                <app-field>
                  <input type="text" class="input-text" maxlength="8" fieldRegexp [regexp]="'[^0-9]'" [(ngModel)]="communicatorOpenCrashLimit" />
                </app-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-16" *ngIf="ticketsSettingsError">
      <app-message [type]="'error'">
        <div message-content>{{ ticketsSettingsError }}</div>
      </app-message>
    </div>

    <div class="mt-16" *ngIf="ticketsSettingsSuccess">
      <app-message [type]="'success'">
        <div message-content>{{ ticketsSettingsSuccess }}</div>
      </app-message>
    </div>

    <div class="mt-32">
      <button class="button" type="button" [disabled]="!checkValidTicketsSettingsForm()" (click)="onSaveTicketsSettings()">Сохранить</button>
    </div>
  </div>
</div>
